export const DashVolume = {
    centerId: null,
    centerAlias: '', 
    year: ' Total Contacts', 
    janCount: 0,
    febCount: 0,
    marCount: 0,
    aprCount: 0,
    mayCount: 0,
    junCount: 0,
    julCount: 0,
    augCount: 0,
    sepCount: 0,
    octCount: 0,
    novCount: 0,
    decCount: 0,
    total: 0
}